import React from 'react';
import DashboardShell from '../../../layouts/DashboardShell';
import HiredJobCard from '../components/HiredJobCard';
import useHiredApplicants from '../../../features/jobs/hooks/useHiredApplicants';
import { clientSideLinks } from '../clientRoutes';
import CardIcon from '../../../shared/components/icons/CardIcon';

function HiredJobsPage() {
  const { groups, loading, error, reload } = useHiredApplicants();

  return (
    <DashboardShell role="CLIENT" sideLinks={clientSideLinks}>
      <div className="space-y-6">
        <div className="rounded-3xl bg-white p-6 shadow-sm">
          <h1 className="flex items-center gap-3 text-2xl font-bold text-navy"><CardIcon name="briefcase" className="h-6 w-6" />Hired Jobs</h1>
          <p className="mt-2 text-sm text-slate-600">Manage active assignments and the workers you hired.</p>
        </div>

        {error && <div className="rounded-3xl bg-rose-50 p-8 text-center text-rose-700 shadow-sm">Error: {error}</div>}
        {!error && loading && <div className="rounded-3xl bg-white p-8 text-center text-slate-600 shadow-sm">Loading hired jobs...</div>}
        {!error && !loading && groups.length === 0 && <div className="rounded-3xl bg-white p-8 text-center text-slate-500 shadow-sm">No hired jobs found.</div>}
        {!error && !loading && groups.length > 0 && (
          <div className="space-y-5">
            {groups.map((group) => <HiredJobCard key={group.job?.id} group={group} onCompleted={reload} />)}
          </div>
        )}
      </div>
    </DashboardShell>
  );
}

export default HiredJobsPage;
